import { Navigate, useSearchParams, useLocation } from "react-router-dom";
import { useUserContext } from "../../context/UserContext";
import { useEffect, useState } from "react";

export const PublicRoute = ({ children }: any) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { fetchingUserData } = useUserContext();
  const [hasInitiallyChecked, setHasInitiallyChecked] = useState(false);
  
  // List of paths that should always be accessible regardless of auth status
  const publicPaths = ["/", "/hardware", "/rec-setup", "/pricing", "/arrange", "/waitlist"];
  const currentPath = location.pathname;
  
  useEffect(() => {
    // Mark that we've done the initial check
    if (!fetchingUserData && !hasInitiallyChecked) {
      setHasInitiallyChecked(true);
    }
  }, [fetchingUserData, hasInitiallyChecked]);
  
  // Always allow access to public paths
  if (publicPaths.includes(currentPath)) {
    return children;
  }
  
  // Allow access if coming from email
  if (searchParams.get("from") === "email") {
    return children;
  }
  
  // During initial load or while fetching user data, show the page
  if (!hasInitiallyChecked || fetchingUserData) {
    return children;
  }
  
  // Check authentication status
  const hasToken = localStorage.getItem("access_token");
  const isOnboarding = localStorage.getItem("onboarding_in_progress");
  const hasEmailLogin = localStorage.getItem("user_email_login");
  
  // Allow access if not authenticated or in onboarding without email login
  if (!hasToken || (isOnboarding && !hasEmailLogin)) {
    return children;
  }

  // Redirect authenticated users to account page
  return <Navigate to={`/account${location.search}`} />;
};
